/**
 * @fileoverview POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/provision" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeProvisionCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdEmailSelfServeProvisionProps,
  PostProvisionSesAccountErrors,
  PostProvisionSesAccountResult,
} from "./types";

export const postProvisionSesAccount = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeProvisionCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostProvisionSesAccountErrors>()(
    ({
      companyId,
      appGroupId,
    }: PostCompaniesCompanyIdEmailSelfServeProvisionProps): Promise<PostProvisionSesAccountResult> => {
      return fetch(`/companies/${companyId}/email_self_serve/${appGroupId}/provision`, "POST", {}, undefined, {
        // don't display a modal on fetch errors — the scene shows its own UI
        propagateFetchRequestError: false,
      });
    }
  )
);
